import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddSupplierLayers from "../components/AddSupplierLayer";


const AddSupplyLayer = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Supplier" />

        {/* AddUserLayer */}
        <AddSupplierLayers />


      </MasterLayout>
    </>
  );
};

export default AddSupplyLayer;
